<template>
  <div class="rm-screen">
    <div v-if="loading && !restaurantMeals.length" class="rm-empty">
      <v-progress-circular indeterminate color="#c2410c"></v-progress-circular>
    </div>
    <div v-else-if="!restaurants.length" class="rm-empty">
      <template v-if="filters.search">{{ $t("report_mobile.no_results_for", { search: filters.search }) }}</template>
      <template v-else>
        <v-icon size="40" color="#8a817a">mdi-storefront-outline</v-icon>
        {{ $t("no_data_available") }}
      </template>
    </div>

    <template v-else>
      <div class="rm-stats rm-stats--pair">
        <div class="rm-stat rm-stat--inverse">
          <span class="rm-stat__label">{{ $t("report_desktop.total_meals") }}</span>
          <span class="rm-stat__value rm-num">{{ mealTotal }}</span>
        </div>
        <div class="rm-stat">
          <span class="rm-stat__label">{{ $t("number_of_orders") }}</span>
          <span class="rm-stat__value rm-num">{{ orderTotal }}</span>
        </div>
      </div>

      <ul class="rm-list rm-card">
        <li v-for="restaurant in restaurants" :key="restaurant.key" class="rm-mrow">
          <div class="rm-mrow__main">
            <span class="rm-mrow__name">{{ restaurant.name }}</span>
            <span class="rm-mrow__value rm-num">{{ restaurant.count }}</span>
          </div>
          <div
            class="rm-progress gm-rest-share"
            role="progressbar"
            :aria-valuenow="restaurant.count"
            aria-valuemin="0"
            :aria-valuemax="mealTotal"
          >
            <div class="rm-progress__fill" :style="{ width: `${restaurant.percent}%` }"></div>
          </div>
          <div class="rm-muted rm-num gm-rest-orders">
            {{ $t("number_of_orders") }}: {{ restaurant.orders }}
          </div>
        </li>
      </ul>
    </template>
  </div>
</template>

<script>
import ReportTabGroupMealsTabRestaurants from "@/components/report/group-meals/ReportTabGroupMealsTabRestaurants.vue";
import { percentOf } from "../../../shared/takenMath";
import "../reportMobileMealCards.scss";

/**
 * Mobilni "Restorani" (jela iz grupa): koliko je obroka i narudžbi po restoranu koji hrani firme, sa udjelom u
 * ukupnom. Pretraga je u lupi zaglavlja. Nasleđuje učitavanje, štampu i Excel iz starog taba; ako odgovor ima i
 * svoj red "UKUPNO", on nije restoran.
 */
export default {
  name: "GroupMobileRestaurants",
  extends: ReportTabGroupMealsTabRestaurants,
  computed: {
    items() {
      const total = String(this.$t("totalU")).toLowerCase();
      return this.translatedRestaurantMeals.filter(
        (row) => !["ukupno", total].includes(String(row.name || "").trim().toLowerCase())
      );
    },
    mealTotal() {
      return this.items.reduce((sum, row) => sum + (Number(row.count) || 0), 0);
    },
    orderTotal() {
      return this.items.reduce((sum, row) => sum + (Number(row.orders_count) || 0), 0);
    },
    /** Restorani po broju obroka (najviše prvi); pretraga po nazivu. */
    restaurants() {
      const found = this.filters.search ? this.customSearch(this.items, [{ value: "name" }], this.filters.search) : this.items;
      return [...found]
        .sort((a, b) => (Number(b.count) || 0) - (Number(a.count) || 0) || a.name.localeCompare(b.name))
        .map((row, index) => ({
          key: `${row.name}-${index}`,
          name: row.name,
          count: Number(row.count) || 0,
          orders: Number(row.orders_count) || 0,
          percent: percentOf(Number(row.count) || 0, this.mealTotal),
        }));
    },
  },
};
</script>

<style lang="scss">
.rm-theme .gm-rest-share {
  margin-top: 8px;
  height: 6px;
}

.rm-theme .gm-rest-orders {
  margin-top: 6px;
  font-size: 12px;
}
</style>
